document.addEventListener("DOMContentLoaded", addRedirectToAvailableCtas);

function addRedirectToAvailableCtas() {
    const ctas = document.querySelectorAll(".js-ma-cta");
    if (ctas.length === 0) return;

    ctas.forEach((cta) => cta.addEventListener("click", addRedirect));
}

function addRedirect() {
    const redirectUrl = getRedirectUrl(this);
    redirectTo(redirectUrl);
}

function getRedirectUrl(item) {
    const ctaUrl = item.closest(".ma-cta").dataset.ctaAction;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.append("aud_cta", "ma-cta");

    return ctaUrl + "?" + searchParams.toString();
}

function redirectTo(url) {
    window.location.href = url;
}
